<template>
  <div class="min-height-300 bg-primary position-absolute w-100"></div>
  <!-- Sidebar -->
  <Sidebar />
  <!-- End Sidebar -->

  <main class="main-content position-relative border-radius-lg">
    <!-- Navbar -->
    <Navbar>
      <template v-slot:breadcrumb><slot name="breadcrumb"></slot></template>
      <template v-slot:header><slot name="header"></slot></template>
    </Navbar>
    <!-- End Navbar -->

    <div class="container-fluid py-4">
      <!--Content-->

      <flash-message v-if="$page.props.flash"></flash-message>

      <slot name="content"></slot>

      <!--End Content-->

      <!----footer-->
      <Footer />
      <!----footer-->
    </div>
  </main>
</template>

<script>
import Footer from "@/Components/Footer";
import Navbar from "@/Components/Navbar";
import Sidebar from "@/Components/Sidebar";
import FlashMessage from "@/Components/FlashMessage";
import { usePage } from "@inertiajs/inertia-vue3";
export default {
  components: {
    Footer,
    Navbar,
    Sidebar,
    FlashMessage,
  },

  mounted() {
    /*   const iconNavbarSidenav = this.$el.querySelector("#iconNavbarSidenav");
    const iconSidenav = this.$el.querySelector("#iconSidenav"); */

    const iconNavbarSidenav = document.querySelector("#iconNavbarSidenav");
    const iconSidenav = document.querySelector("#iconSidenav");

    if (iconNavbarSidenav) {
      iconNavbarSidenav.addEventListener("click", this.toggleSidenav);
    }

    if (iconSidenav) {
      iconSidenav.addEventListener("click", this.toggleSidenav);
    }
  },
  beforeUnmount() {},

  methods: {
    toggleSidenav() {
      const body = document.querySelector("body");
      const className = "g-sidenav-pinned";
      const sidenav = document.querySelector("#sidenav-main");
      const iconSidenav = document.querySelector("#iconSidenav");

      if (body.classList.contains(className)) {
        body.classList.remove(className);
        setTimeout(function () {
          sidenav.classList.remove("bg-white");
        }, 100);
        sidenav.classList.remove("bg-transparent");
      } else {
        body.classList.add(className);
        sidenav.classList.add("bg-white");
        sidenav.classList.remove("bg-transparent");
        iconSidenav.classList.remove("d-none");
      }
    },
  },
};
</script>
